import { create } from 'zustand';

/** A lat/lng bounding box (already margin-expanded). */
export interface ViewportBox {
  north: number;
  south: number;
  east: number;
  west: number;
}

/** Normalized viewport descriptor that drives viewport culling, mode-agnostic. */
export interface ViewportState {
  /** Visible box plus margin, or null until the first camera settle. */
  box: ViewportBox | null;
  /** Viewport center (for the nearest-to-center cap). */
  center: { lat: number; lng: number } | null;
  /** True when zoomed/ranged in far enough that culled layers should render. */
  active: boolean;
}

/** Store + setter for the current map viewport. */
interface MapViewportStore extends ViewportState {
  /** Publish the latest viewport (called by the debounced camera hook). */
  setViewport: (next: ViewportState) => void;
}

/** Holds the current normalized viewport; written by the camera hook, read by the cull. */
export const useMapViewportStore = create<MapViewportStore>((set) => ({
  box: null,
  center: null,
  active: false,
  setViewport: (next) => set(next),
}));
